<template>
    <div class="form-group select">
        <label
            :for="name"
            class="control-label"
        >
            <slot>Registration Category</slot>
        </label>
        <select
            :name="name"
            :id="name"
            v-model="model"
            data-vv-as="registration category"
            class=" form-control"
            v-validate.immediate="{ required: true }"
            data-vv-validate-on="change">
            <option
                value=""
                v-text="registrationCategories.length ? `--Select Registration Category--` : `--No Registration Categories Found--`"
            ></option>
            <option
                v-for="registrationCategory in displayableRegistrationCategories"
                :key="registrationCategory.id"
                :value="registrationCategory.id"
                v-text="registrationCategory.name"
            ></option>
        </select>
        <span class="text-danger"
              v-if="vErrors.has(name)">This field cannot be left empty</span>
    </div>
</template>

<script>
//See if we can factor this out and use EntitySelectMenu instead.
export default {
    name: "RegistrationCategorySelect",
    inject: ['$validator'],
    props: {
        name: {
            default: `registration_category_id`,
            required: false,
            type: String,
        },

        registrationCategories: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            model: ''
        }
    },
    computed: {
        displayableRegistrationCategories() {
            return this.registrationCategories
                .map(registrationCategory => {
                    let {id, name, date} = registrationCategory;

                    return {
                        id,
                        name: `${name} - ${moment(date).format('DD/MM/YYYY')}`,
                    }
                });
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/RegistrationCategorySelect.vue